import type { ReactNode } from 'react';
import { Layout, theme } from 'antd';
import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { useAppStore, useResponsive } from '@/shared';
import styles from './MainLayout.module.css';

const { Content } = Layout;

interface MainLayoutProps {
  children: ReactNode;
}

export const MainLayout = ({ children }: MainLayoutProps) => {
  const sidebarCollapsed = useAppStore((state) => state.sidebarCollapsed);
  const { isMobile } = useResponsive();
  const {
    token: { colorBgElevated, borderRadiusLG },
  } = theme.useToken();

  const mainAreaClass = isMobile
    ? styles.mainAreaMobile
    : sidebarCollapsed
      ? styles.mainAreaCollapsed
      : styles.mainAreaExpanded;

  return (
    <Layout className={styles.layout}>
      <Sidebar />

      <Layout className={`${styles.mainArea} ${mainAreaClass}`}>
        <Header />
        <Content
          className={styles.content}
          style={{
            background: colorBgElevated,
            borderRadius: borderRadiusLG,
          }}
        >
          {children}
        </Content>
      </Layout>
    </Layout>
  );
};
